import { Menu } from '@dashboard/entities/menu';
import { http } from '@dashboard/common/http';
import { getEnvVar } from '@dashboard/common/utils';

const transformMenuWhatsApp = (menu: Menu[]): Menu[] => {
  let whatsappItem: Menu | null = null;
  let tiendaIndex = -1;

  // Buscar WhatsApp en Ventas y guardar referencia
  menu.forEach((section, idx) => {
    if (section.name === "Ventas" && section.subMenu) {
      const whatsappIdx = section.subMenu.findIndex(item =>
        item.name?.toLowerCase().includes('whatsapp') ||
        item.id?.toLowerCase().includes('whatsapp')
      );
      if (whatsappIdx !== -1) {
        whatsappItem = { ...section.subMenu[whatsappIdx], name: "Botón flotante" };
        section.subMenu.splice(whatsappIdx, 1);
      }
    }
    if (section.name === "Tienda") {
      tiendaIndex = idx;
    }
  });

  // Si encontramos WhatsApp y la sección Tienda existe, agregar a Tienda
  if (whatsappItem && tiendaIndex !== -1) {
    if (!menu[tiendaIndex].subMenu) {
      menu[tiendaIndex].subMenu = [];
    }
    menu[tiendaIndex].subMenu?.push(whatsappItem);
  }

  return menu;
};

export const fetchMenu = async (): Promise<Menu[]> => {
  const response = await http.get("/api/ms/remote-config/country-data/dashboard_menu", {
    headers: {
      'api-key-sumer': getEnvVar('REACT_APP_KEY_SP'),
    },
  });
  const menu = response.data.value.menu;
  return transformMenuWhatsApp(menu);
};
